import { Box } from '@chakra-ui/react';
import { PropsWithChildren } from 'react';

export const ArticleContent = ({ children }: PropsWithChildren<unknown>) => {
  return (
    <Box
      mt="md"
      sx={{
        color: 'white',
        // Defines space between each direct child tag, similar to Chakra's Stack component
        '> * + *': {
          mt: 'space.16',
        },
        h3: {
          fontSize: 'md',
          lineHeight: 1.1,
          fontWeight: 'bold',
          mt: 'space.32',
        },
        p: {},
        ul: {
          marginInlineStart: 'lg',
          color: 'white',
          'li::marker': {
            fontSize: 'lg',
            color: 'white',
          },
        },
        'a, a:visited': {
          textDecoration: 'underline',
        },
        'a:hover': {
          opacity: 0.4,
          textDecoration: 'underline',
        },
      }}
    >
      {children}
    </Box>
  );
};
